/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsErrorResponse } from "../../entities/models/ErrorResponse";
import { z } from "zod/v4";

/**
 * @description Standard error response
 */
export const modelsErrorResponseSchema = z.object({
    "error": z.optional(z.string().describe("Error type\nExample: bad_request")),
"error_code": z.optional(z.int().describe("ErrorCode\nExample: 1001")),
"message": z.optional(z.string().describe("Human-readable error message\nExample: invalid credentials"))
    }).describe("Standard error response") as unknown as z.ZodType<ModelsErrorResponse>